// @flow
import api from 'common/services/api';
import SpotSchedule from '../domain/SpotSchedule';

class SalesInventoryAPI {

  buildHeaders = (token: string) => ({ Authorization: 'Bearer ' + token });

  async updateSpotSchedule(token: string, callSign: string, spotSchedule: SpotSchedule): Promise<*> {
    const path = `/statsradio/${callSign}/sales-inventory/schedule`;
    const data = spotSchedule.toObject();

    await api.put(path, data, {
      headers: this.buildHeaders(token),
    });
  }

  async fetchSpotSchedule(token: string, callSign: string): Promise<SpotSchedule> {
    const path = `/statsradio/${callSign}/sales-inventory/schedule`;
    const { data } = await api.get(path, {}, {
      headers: this.buildHeaders(token),
    });

    return SpotSchedule.fromObject(data);
  }
}

export default new SalesInventoryAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesInventory/services/SalesInventoryAPI.js